import styled from 'styled-components';

interface TranslationStatusWrapperProps {
  status: 'pending' | 'success' | 'error';
}

const getBackgroundColor = (status: TranslationStatusWrapperProps['status']) : string => {
  switch (status) {
    case 'pending':
      return '#FFF3E0';
    case 'error':
      return '#FFEBEE';
    default:
      return 'transparent';
  }
};

const getBorderColor = (status: TranslationStatusWrapperProps['status']): string => {
  switch (status) {
    case 'pending':
      return '#FF9800';
    case 'error':
      return '#F44336';
    default:
      return '#000';
  }
};

const getTextColor = (status: TranslationStatusWrapperProps['status']): string => {
  switch (status) {
    case 'pending':
      return '#FF9800';
    case 'error':
      return '#F44336';
    default:
      return '#000';
  }
};

export const TranslationStatusWrapper = styled.div<TranslationStatusWrapperProps>`
    height: 22px;
    background-color: ${({ status }) => getBackgroundColor(status)};
    border-radius: 12px;
    border: 1px solid ${({ status }) => getBorderColor(status)};
    padding: 0 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-size: 11px;
    color: ${({ status }) => getTextColor(status)};
    font-weight: 400;
  position: relative;
  z-index: 2;
`;
